import { render } from "./Team_partner_en_m.vue?vue&type=template&id=6868227d&scoped=true"
import script from "./Team_partner_en_m.vue?vue&type=script&lang=js"
export * from "./Team_partner_en_m.vue?vue&type=script&lang=js"

import "./Team_partner_en_m.vue?vue&type=style&index=0&id=6868227d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6868227d"

export default script